import React, { useState, useEffect } from 'react';
import './StationDashboard.css';

const STATIONS = [
  { key: 'carting', label: 'Carting' },
  { key: 'wicking', label: 'Wicking' },
  { key: 'pouring', label: 'Pouring' },
  { key: 'packaging', label: 'Packaging' }
];

function StationDashboard() {
  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState([]);
  const [lastUpdated, setLastUpdated] = useState(null);

  const getStartOfWeek = () => {
    const now = new Date();
    const day = now.getDay(); // 0 = Sunday
    const diff = now.getDate() - day; // Go back to Sunday
    const sunday = new Date(now.setDate(diff));
    sunday.setHours(0, 0, 0, 0);
    return sunday.toISOString();
  };

  useEffect(() => {
    fetchInProduction();
    const interval = setInterval(fetchInProduction, 30000);
    return () => clearInterval(interval);
  }, []);

  const fetchInProduction = async () => {
    try {
      const since = getStartOfWeek();
      const response = await fetch(`/api/in-production?since=${encodeURIComponent(since)}`);
      const data = await response.json();
      setItems(data);
      setLastUpdated(new Date());
      setLoading(false);
    } catch (err) {
      console.error('Error fetching in-production:', err);
      setLoading(false);
    }
  };

  const getItemsByStation = (stationKey) => {
    const stationItems = items.filter(item => item.status === stationKey);

    const grouped = {};
    stationItems.forEach(item => {
      const desc = item.item_description || item.item_sku;
      if (!grouped[desc]) {
        grouped[desc] = {
          description: desc,
          totalUnits: 0
        };
      }
      grouped[desc].totalUnits += item.units;
    });

    return Object.values(grouped).sort((a, b) => b.totalUnits - a.totalUnits);
  };

  const getTotalUnits = (stationKey) => {
    return items
      .filter(item => item.status === stationKey)
      .reduce((sum, item) => sum + item.units, 0);
  };

  if (loading) {
    return (
      <div className="station-dashboard loading">
        <div className="spinner"></div>
        <p>Loading production data...</p>
      </div>
    );
  }

  return (
    <div className="station-dashboard">
      <div className="dashboard-header">
        <h1>This Week's Production</h1>
        {lastUpdated && (
          <span className="last-updated">
            Updated {lastUpdated.toLocaleTimeString()}
          </span>
        )}
      </div>

      <div className="stations-list">
        {STATIONS.map(station => {
          const stationItems = getItemsByStation(station.key);
          const totalUnits = getTotalUnits(station.key);

          if (stationItems.length === 0) return null;

          return (
            <div key={station.key} className="station-section">
              <div className="station-title">
                <span className="station-name">{station.label}</span>
                <span className="station-total">{totalUnits.toLocaleString()} units</span>
              </div>
              <div className="station-items-list">
                {stationItems.map((item, idx) => (
                  <div key={idx} className="item-row">
                    <span className="item-desc">{item.description}</span>
                    <span className="item-units">{item.totalUnits.toLocaleString()}</span>
                  </div>
                ))}
              </div>
            </div>
          );
        })}

        {items.length === 0 && (
          <div className="empty-state">
            No items in production this week
          </div>
        )}
      </div>
    </div>
  );
}

export default StationDashboard;
